import { all } from "redux-saga/effects";

import accountInfoSaga from "./accountInfo";
import ChangeAvatarSaga from "./changeAvatar";
import ChangeImageBirthdaySaga from "./changeImageBirthday";
import DeleteImageBirthdaySaga from "./deleteImageBirthday";
import getRoleMenuSaga from "./roleMenu";
import getPermissionItemSaga from "./roleItem";

export default function* layoutSaga() {
  yield all([
    accountInfoSaga(),
    ChangeAvatarSaga(),
    ChangeImageBirthdaySaga(),
    DeleteImageBirthdaySaga(),
    getRoleMenuSaga(),
    getPermissionItemSaga(),
  ]);
}
